export default __webpack_public_path__ + "static/media/Cloudxier-EMILIANUS-Profile-Finance.31863ed0.png";